// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RecommendedLabel/RecommendedLabel.scss
// module id = 1402
// module chunks = 10